import type { RegionalTeachersDto } from '../../regionalApi';

export const EM_DASH = '—';

/** Grid cell values: an assignment, a declared slot, or nothing set. */
export type AvailabilityGridCell = RegionalTeachersDto['availability'][string][number];
export type LegendKey = 'shift' | 'all_day' | 'daytime' | 'evening' | 'off';

export const CELL_STYLES: Record<LegendKey, { label: string; swatch: React.CSSProperties }> = {
  shift: { label: 'Shift', swatch: { background: 'var(--nb-primary)' } },
  all_day: { label: 'All day', swatch: { background: 'var(--nb-primary-soft)' } },
  daytime: {
    label: 'Daytime',
    swatch: { background: 'var(--nb-primary-soft)', opacity: 0.6 },
  },
  evening: {
    label: 'Evening',
    swatch: {
      background: 'var(--nb-primary-soft)',
      borderBottom: '3px solid var(--nb-primary)',
    },
  },
  off: {
    label: 'Off',
    swatch: { background: 'var(--nb-warn-soft)', border: '1px dashed var(--nb-warn)' },
  },
};

export const LEGEND_ORDER: LegendKey[] = ['shift', 'all_day', 'daytime', 'evening', 'off'];

export const DAY_HEADS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
